<template>
	<app-badge class="gap-2" size="medium" theme="outline">
		{{ label }}

		<div class="w-5">
			<app-svg
				:path="`/icons/catalyst/${icon}.svg`"
				:colour="statusKey == 'load_status' ? '#002855' : undefined"
				:background="colour"
				autoscale />
		</div>
	</app-badge>
</template>

<script lang="ts" setup>
	import { useContractStatus } from '@/composables/status'
	import AppSvg from '@/components/base/AppSvg.vue'

	const props = defineProps({
		status: {
			type: Object,
			default: undefined
		},
		statusKey: {
			type: String,
			default: 'status'
		}
	})

	const { icon, colour, label } = useContractStatus(
		props.status?.[props.statusKey] ?? 0,
		props.statusKey == 'load_status' ? 'load' : (props.status?.sub_status ?? undefined)
	)
</script>
